import { render, staticRenderFns } from "./TaskNew.vue?vue&type=template&id=341e6f32&scoped=true"
import script from "./TaskNew.vue?vue&type=script&lang=js"
export * from "./TaskNew.vue?vue&type=script&lang=js"
import style0 from "./TaskNew.vue?vue&type=style&index=0&id=341e6f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341e6f32",
  null
  
)

export default component.exports